import { render, staticRenderFns } from "./OKR.vue?vue&type=template&id=06978107&"
import script from "./OKR.vue?vue&type=script&lang=js&"
export * from "./OKR.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports